import { memo } from "react";
import { formatToValue } from "../../../../utils/formatNumber";
import { CustomChartToolTip } from "../../styles/DashBoard";

const Tooltip = ({ active, payload, situations, isEmpty }) => {
  if (!active || !payload?.length || isEmpty) return null;

  return (
    <CustomChartToolTip>
      {payload.map((index) => (
        <p key={index.name} style={{ color: index.payload?.fill }}>
          {situations[index.name].label}: R$ {formatToValue(index.value)}
          {"\n"}
        </p>
      ))}
    </CustomChartToolTip>
  );
};

export default memo(Tooltip);
